/**
 * Album label mapping for show names
 * Single source of truth for album divider labels
 */
export const ALBUM_LABELS: Record<number, string> = {
  1: "LOVE LANGUAGE FM",
  2: "SHENGE BREAKFAST SHOW",
  3: "MAPHOLOBA SHOW",
  4: "THANDEKA DRIVE TIME SHOW",
  5: "SILINDILE DRIVE TIME",
  6: "SEBENZILE AFTERNOON DRIVE",
  7: "MALUME SUNDAY SHOW",
  8: "SIBONISO NIGHT DRIVE",
  9: "NTHABI'S DAY TIME SHOW",
  10: "NTOMBI'S RIDE OR DIE SHOW",
  13: "MASONDO AFTERNOON DRIVE",
  14: "MBHELE ON AIR",
  15: "ZONDI FAMILY SHOW",
  16: "MBONGENI ON AIR",
  17: "MAQHUDE HOUR",
  19: "ACTUAL DEDICATIONS",
  20: "NDODA AFTERNOON SHOW",
  21: "LATEST DEDICATIONS",
};

export function albumLabel(id: number): string {
  return ALBUM_LABELS[id] ?? `Album ${id}`;
}
